module.exports = __webpack_public_path__ + "media/images/logo-b8957d02d6a007ce048d82c1ce496af5.svg";